export default "__VITE_ASSET__BLIAbogd__"